import React from 'react'
import { saveAs } from 'file-saver'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RestUtilities from '../services/Base';

interface Props {
  lotCode: any;
  coAFileName: string
  uploader:  (selectedFiles: FileList|null) => void
  uploading: boolean
  licensedProducer: string
  sku: string
  harvestDate: string
}

const CoAModalView = (props: Props) => {
  const renderUploadButton = () => {
    return (
      <div style={{ textAlign: "center", display:"inline", paddingLeft:"10px" }}>
          <input onChange={(e) =>{ props.uploader(e.target.files)}} type="file" name="file2" id="file2"  accept="application/pdf"/>
          {props.uploading ? <FontAwesomeIcon icon="spinner" spin /> : <label className="hiddenInput" htmlFor="file2">
            <div style={{ padding:"7px"}} className="btn btn-orange">
              Upload New CoA
            </div>
          </label>}
        </div>
      )
  }

  const getCoa = async () => {
    const downloadLink = `/api/lot/${props.licensedProducer}/${props.lotCode.harvestDate}/${props.lotCode.lotCodeId.trim()}/${props.sku.trim()}/coa`;
    const response = await RestUtilities.get(downloadLink);
    saveAs(response.content, props.coAFileName.trim());
  }

  return (
    <div>
      <div className="form-row">
          <h4>Certificate of Analysis (CoA)</h4>
      </div>
      <div className="form-row">
        <div className="col-6" style={{ "padding": "10px 20px" }}>{`Current CoA: ${props.coAFileName ?? "No File"}`}</div>
        <div className="col-6" style={{ textAlign:"right" }}>
          {!props.uploading && props.coAFileName && props.coAFileName.trim().length > 0 && <button className="btn btn-orange" onClick={getCoa}>
                Download CoA
          </button>}
          {renderUploadButton()}
        </div>
      </div>
    </div>
  );
}

export default CoAModalView;
